import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
  methods: {
    render() {
      this.renderChart(this.chartdata, this.options);
    }
  },
  watch: {
    chartdata: {
      deep: true,
      handler() {
        this.render();
      }
    },
    options: {
      deep: true,
      handler() {
        this.render();
      }
    }
  }
};
